<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15XN0l6/Images/FC-9781528967907.jpg?1692132232163" alt="This image is the cover for the book Three Months in a French Villa – You Can Do It Too!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Three Months in a French Villa – You Can Do It Too!
      </h1>
      <p class="bookDescription body article font2">
        <p>The mention of spending time in a French villa brings to mind so many intriguing thoughts - of white plaster-covered villa walls, grape vines climbing on a trellis outside a lace-curtained window, glasses of red wine being consumed on a sunny afternoon in a pretty garden, eating slices of bread smothered in lashings of olive butter. The images go on and on in one's mind and one is tempted to say "Damn it - I want to do it - I want to live in a French villa and experience life at its best - even if it can only be for the limit of three months". This is how we felt, so we started from scratch, knowing nothing of rural France, except that we wanted a villa in a centuries-old town. It was just the most wonderful three months of our lives. As we could not speak French, it was a difficulty, as no French person in Aubusson could speak English. But what fun it was trying to be understood!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Rees Gow
      </h2>
      
      <p class="authorDescription body article">This is Margaret's fourth book, published by Austin Macauley. This one is different to the others in that it is in diary-format, and written during her three months in a French villa, in the rural town of Aubusson, in the southern part of France. Margaret had her first book published at the age of 68, and from then she has been inspired to keep writing and sharing her unique style. Her children's books are a delight to the older readers as well as the targeted young readers - which makes her writing style widely appreciated. This book will appeal to those that want the adventure of living in a French villa, or those that can only ever dream of it!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34e759ec